export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email) => EMAIL_REGEX.test(String(email || '').trim());

export const normalizeLoginIdentifier = (identifier) =>
  String(identifier || '').trim().toLowerCase();

export const sanitizePassword = (password) => String(password || '').trim();

export const validateUserSession = (user) => {
  if (!user) return false;
  if (!user.uid || !user.email) return false;

  return true;
};

export const validateLoginFormInput = (identifier, password) => {
  if (!identifier || !password) {
    return 'Моля, попълнете всички полета.';
  }

  if (String(identifier).trim().length < 3) {
    return 'Потребителското име трябва да бъде поне 3 символа.';
  }

  if (String(password).trim().length < 6) {
    return 'Паролата трябва да бъде поне 6 символа.';
  }

  return null;
};

